import React, { memo } from 'react'
import { BWMenuItem } from 'src/libs/qb-brand-web-components'
import { Link } from 'react-router-dom'
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import { useTranslation } from 'react-i18next'

import { CONTACT_US_URL } from '../constants/navigation'

const ContactLinkWrapper = () => {
  const { t } = useTranslation()
  return (
    <BWMenuItem
      label={t('brand:user.contact-us.page-title')}
      to={CONTACT_US_URL}
      as={Link}
      icon={faCircleInfo}
    />
  )
}

export default memo(ContactLinkWrapper)
